const React = require('react');
const Ripple = require('../../../../../dumb/Ripple');

module.exports = (props) => {
  return (
    <Ripple className="w layoutRow aiC pt23 pr22 pb29 r9 bgFAFAFA bxsh4c0.25">
      <div className="w1/3 layoutRow jcC aiC">
        <svg width="26" height="34" viewBox="0 0 26 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 17L13 27M13 27L23 17M13 27V1M1 33H25" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <div className="w2/3">
        <span className="dB f12 fw7">
          Upload files
        </span>
        <span className="dB mt8 f10 lh14 c828282">
          Accepted types - PDF, Scanned copy, Clear photo JGEG,
          JPG, PNG and not more than 5 MB each document.
        </span>
      </div>
    </Ripple>
  )
}